/**
 * This component used get the image or video based on meta data received in props
 *
 * @module views/components/MediaWrapper
 * @memberof -Common
 */
import './MediaWrapper.scss';

import React, { useRef } from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import Video from '@ulta/core/components/Video/Video';

import { addZoomInContainer } from '@ulta/utils/zoomUtils/zoomUtils';

/**
 * Represents a MediaWrapper component
 *
 * @method
 * @param {MediaWrapperProps} props - React properties passed from composition
 * @returns MediaWrapper
 */
export const MediaWrapper = function( { mediaContent, show } ){
  const ref = useRef();
  if( mediaContent?.metaData?.mediaType === 'video' ){
    return (
      <div className={ classNames( 'MediaWrapper MediaWrapper__Video', { 'MediaWrapper--show': show } ) }>
        <Video
          imageUrl={ mediaContent.imageUrl }
          videoUrl={ mediaContent.videoUrl || '' }
          alt={ mediaContent.altText }
          closedCaptionUrl={ mediaContent.closedCaptionUrl }
          metaData={ mediaContent.metaData }
          ariaLabel={ mediaContent.altText }
          isCaptionsEnabled={ mediaContent.isCaptionsEnabled }
          videoProfiles={ mediaContent.videoProfiles }
        />
      </div>
    );
  }
  else {
    const src = mediaContent?.imageUrl?.split( '?' );
    const imgSrc = `${src?.[0]}?w=1080&h=1080&fmt=auto`;
    return (
      <div className={ classNames( 'MediaWrapper', { 'MediaWrapper--show': show } ) }>
        <div className='MediaWrapper__Image'
          onMouseMove={ addZoomInContainer }
          ref={ ref }
          style={ { backgroundImage: `url(${imgSrc})` } }
        >
          <img
            src={ imgSrc }
            width={ mediaContent.width }
            alt={ mediaContent.altText }
          />
        </div>
      </div>
    );
  }
};

/**
 * Property type definitions
 * @typedef MediaWrapperProps
 * @type {object}
 * @property {object} mediaContent - Sets the media data
 * @property {boolean} show - Show
 */
export const propTypes =  {
  mediaContent: PropTypes.object.isRequired,
  show: PropTypes.bool
};

MediaWrapper.propTypes = propTypes;

export default MediaWrapper;
